/** A landing publica da calculadora (isca de aquisicao), sem login. */
export function isCalculadoraPath(pathname: string): boolean {
  return pathname === '/calculadora' || pathname.startsWith('/calculadora/');
}
